/**
 * @generated SignedSource<<682d4685e453e1fc4bf7d05848198856>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLJobTaskType = "AGENT" | "AGENT_DASHBOARD_SNAPSHOT" | "ALERT_INSIGHTS" | "ALERT_RESPONDER" | "ALERT_THREAD_LEARNING" | "AWS_MARKETPLACE_METERING" | "BITBUCKET_TOKEN_REFRESH" | "BUILDKITE_SYNC" | "CODE_PULL" | "CREDITS_COMPUTATION_V2" | "CTA_REMINDER" | "CUSTOMER_AGENT_IMAGE_BUILD" | "CUSTOMER_AGENT_SANDBOX_IMAGE_CACHE" | "CUSTOM_MCP_SERVER_TOOL_REFRESH" | "DAG_AGENT" | "DATABRICKS_MEMORY_INGESTION" | "DATABRICKS_SYNC" | "DATABRICKS_TO_POSTGRES_SYNC" | "DIGEST" | "GENERIC_LEARNING" | "GITHUB_CODEBASE_ANALYSIS" | "GITLAB_TOKEN_REFRESH" | "GRAFANA_CLOUD_DATASOURCE_SYNC" | "INCIDENT_CHANNEL_LEARNING" | "INCIDENT_DAG_AGENT" | "INCIDENT_KNOWLEDGE_SYNC" | "INGEST_SLACK_CHANNEL" | "NEWRELIC_APPLICATION_SYNC" | "ONBOARDING" | "ONBOARDING_QUESTION_TRAINING" | "PRODUCT_ANALYTICS" | "RESOURCE_FILES_SYNC" | "RESOURCE_SYNC_QUEUE" | "SLACK_CACHE_REFRESH" | "SLACK_USERGROUP_REFRESH" | "SNAPSHOT_CLEANUP" | "SUPPORT_AGENT_METRIC_CALCULATOR" | "SUPPORT_INSTRUCTION_GENERATION" | "TEAM_INSTRUCTION_GENERATION" | "WHAT_TIME_IS_IT_RIGHT_NOW" | "WORKFLOW_INVESTIGATION" | "WORKFLOW_MEMORY_CONSOLIDATION" | "WORKFLOW_MEMORY_EVAL_RECONCILER" | "%future added value";
export type Status = "ACTIVE" | "PAUSED" | "%future added value";
export type DeleteScheduledDigestRunInput = {
  jobId: any;
  runDate: number;
};
export type DeleteScheduledDigestRunMutation$variables = {
  input: DeleteScheduledDigestRunInput;
};
export type DeleteScheduledDigestRunMutation$data = {
  readonly deleteScheduledDigestRun: {
    readonly job: {
      readonly id: any;
      readonly name: string;
      readonly schedule: any | null | undefined;
      readonly status: Status;
      readonly taskType: GraphQLJobTaskType;
    };
    readonly success: boolean;
  };
};
export type DeleteScheduledDigestRunMutation = {
  response: DeleteScheduledDigestRunMutation$data;
  variables: DeleteScheduledDigestRunMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteScheduledDigestRunPayload",
    "kind": "LinkedField",
    "name": "deleteScheduledDigestRun",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJob",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schedule",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteScheduledDigestRunMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteScheduledDigestRunMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f0e48c20c94dd354700647c8db1f79ba",
    "id": null,
    "metadata": {},
    "name": "DeleteScheduledDigestRunMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteScheduledDigestRunMutation(\n  $input: DeleteScheduledDigestRunInput!\n) {\n  deleteScheduledDigestRun(input: $input) {\n    success\n    job {\n      id\n      name\n      schedule\n      taskType\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ad8fcac7e459e874d5b8dac97e7f3dcf";

export default node;
